import React, { useEffect, useState } from "react";
import "./styles.css";
import { Button } from "@mui/material";
import { Favorite, ModeComment } from "@mui/icons-material";
import { teal } from "@mui/material/colors";
import { ProductRes, ProductResDto } from "../../../types/productType";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../State/Store";
import { addProductToWishlist } from "../../../State/customer/WishlistSlice";
import StorefrontIcon from '@mui/icons-material/Storefront';
export const ProductCard = ({item}:{item:ProductResDto}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isHover, setIsHover] = useState(false);
  const dispatch = useAppDispatch()
  // const handleWishList = (productId:number|undefined,e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => { 
  //   e.stopPropagation()
  // productId &&  dispatch(addProductToWishlist(productId))
  //  }
  const navigate = useNavigate()
  //will trigger if isHover is change
  useEffect(() => {
    //setInterval is set the time for callback this function for example set for 1 seconds it will call the function every 1 seconds clear interval is stopping it
    let interval: any;
    if (isHover) {
      interval = setInterval(() => {
        setCurrentImage(
          (prevImage) =>
            //The modulo operation (% images.length) ensures that the image index loops back to 0 when it reaches the end of the images array.
            //because those number divided by 5 can not divided by 5 because it lower so it equal to itself
            (prevImage + 1) % item.images.length
        );
      }, 1000);
    } else if (interval) {
      clearInterval(interval);
      interval = null;
    }
    return () => clearInterval(interval);
  }, [isHover]);
  return (
    <>
      <div onClick={()=>navigate(`/product-details/${item.categoryId}/${item.title}/${item.id}`)} className="group mb-[5vw] relative w-full h-full">
        <div
          className="card "
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          {item.images.map((item, index) => (
           
              <img
              key={index}
              className="card-media object-top "
              src={item}
              alt=""
              style={{
                transform: `translateX(${(index - currentImage) * 100}%)`,
              }}
            />
           
          ))}

          {isHover && (
            <div className="indicator flex flex-col items-center space-y-2">
              <div className="flex gap-3">
                {/* {item.id && (<Button onClick={(e)=>handleWishList(item.id,e)} variant="contained" color="secondary">
                  <Favorite sx={{color:teal[500],}}/>
                </Button>)} */}
                <Button variant="contained" color="secondary">
                  <ModeComment sx={{color:teal[500],}}/>
                </Button>
              </div>
            </div>
          )}
        </div>
        <div className="details pt-3 space-y-1 group-hover-effect rounded-md">
          <div className="name">
        
            <p>{item.title}</p>
          </div>
          <div className="flex justify-start space-x-3 items-center">
            <span>Sold By:</span>
            <h1 className="font-bold">{item.sellerName}</h1>
         </div>
          <div className="price flex items-center gap-3">
            <span className="font-sans text-gray-800">
              {item.sellingPrice}€
            </span>
            <span className="thin-line-through text-gray-400">
              {item.mrpPrice}€
            </span>
            <span className="text-primary font-semibold ">
              {item.discountPercentage}%
            </span>
          </div>
          
        </div>
      </div>
    </>
  );
};
